<template>
    <div class="container" style="margin-top: 200px;">
        <!-- ENCABEZADO -->
        <div class="text-center mb-5">
            <h1 class="fw-bold text-uppercase">{{ paquete.nombre }}</h1>
            <p class="text-muted fs-5">{{ paquete.paises }}</p>
        </div>

        <!-- IMAGEN PRINCIPAL -->
        <div v-if="paquete.img" class="text-center mb-4">
            <img :src="getImageUrl(paquete.img)" alt="Imagen del paquete" class="img-fluid rounded shadow"
                style="max-height: 400px; object-fit: cover;" />
        </div>

        <!-- DETALLES DEL PAQUETE -->
        <div class="card border-0 shadow-lg p-4 mb-5">
            <h4 class="fw-bold mb-3 text-primary">Detalles del paquete</h4>
            <div class="row">
                <div class="col-12 mb-3">
                    <p><strong>Duración:</strong> {{ paquete.duracion }}</p>
                    <p><strong>Vuelo:</strong> {{ paquete.vuelo }}</p>
                    <p><strong>Mes de salida:</strong> {{ paquete.salidaMes }}</p>
                </div>
                <div class="col-12 mb-3">
                    <p><strong>Tarifa:</strong> ${{ paquete.tarifa }} USD</p>
                </div>
            </div>
        </div>

        <!-- NOTAS O INFORMACIÓN ADICIONAL -->
       <!--  <div v-if="paquete.notas" class=">">
            <h5 class="fw-bold mb-2">Notas importantes</h5>
            <p class="mb-0">{{ paquete.notas }}</p>
        </div> -->
        <center>
            <a :href="getDownloadUrl(paquete.pdf)" class="btn btn-outline-primary btn-lg my-3">
                <i class="fa-solid fa-file-pdf"></i> Descargar pdf
            </a>
            <br>
            <a :href="`https://wa.me/525545401703?text=${encodeURIComponent('Hola, me interesa este paquete: http://localhost:8080/Paquete/' + paquete.id)}`"
                target="_blank" class="btn btn-outline-success btn-lg my-3"
                style="gap: 8px;">
                <i class="fab fa-whatsapp"></i> Reservar vía WhatsApp
            </a>
        </center>

    </div>
</template>

<script>
import axios from "axios";

export default {
    name: "PaqueteDetalle",
    data() {
        return {
            paquete: {}
        };
    },
    methods: {
        async fetchPaquete() {
            try {
                const id = this.$route.params.id;
                const response = await axios.get(`https://beauvoyage.net/api/paquete`, {
                    params: { id: id }
                });
                console.log("Paquete cargado:", response.data);
                this.paquete = response.data;
            } catch (error) {
                console.error("Error al cargar el paquete:", error);
            }
        },
        getImageUrl(path) {
            return `https://beauvoyage.net/${path}`;
        },
        getDownloadUrl(path) {
            if (!path) return "#"; // evita error si aún no existe
            const filename = path.split("/").pop();
            return `https://beauvoyage.net/api/descargarPdf/${filename}`;
        }
    },
    created() {
        this.fetchPaquete();
    }
};
</script>
